export const COMPANY = {
  name: "Uusimaa Svets & VVS AB",
  shortName: "Uusimaa",
  phone: "073-743 10 33",
  phoneHref: "tel:+46737431033",
  email: "fredrik.uusimaa@gmail.com",
  emailHref: "mailto:fredrik.uusimaa@gmail.com",
  address1: "Häckgränd 17",
  address2: "137 54 Tungelsta",
  orgNr: "559383-0598",
  area: "Storstockholm",
  motto: "Vi gör vårt bästa, även när ingen ser på.",
};

export const INSTAGRAM = {
  handle: "@uusimaasvetsvvs",
  url: "https://www.instagram.com/uusimaasvetsvvs/",
};

export const NAV_LINKS = [
  { label: "Start", href: "#start", testid: "nav-link-start" },
  { label: "Vad vi lovar", href: "#vad-jag-lovar", testid: "nav-link-loften" },
  { label: "Tjänster", href: "#tjanster", testid: "nav-link-tjanster" },
  { label: "Projekt", href: "#projekt", testid: "nav-link-projekt" },
  { label: "Om oss", href: "#om-mig", testid: "nav-link-om-mig" },
  { label: "Kontakt", href: "#kontakt", testid: "nav-link-kontakt" },
];

export const SERVICES = [
  {
    id: "fjarrvarme",
    num: "01",
    tag: "Vår specialitet",
    title: "Fjärrvärmecentraler",
    description: "Byte, montering och anpassning av fjärrvärmecentraler – vårt största och vanligaste uppdrag.",
    bullets: [
      "Byte av befintlig fjärrvärmecentral",
      "Montering och inkoppling av ny central",
      "Anpassning och svetsning av rörsystem",
      "Service och underhåll",
      "Arbeten för BRF:er och fastighetsägare",
    ],
  },
  {
    id: "vvs",
    num: "02",
    tag: "Installation & ombyggnad",
    title: "VVS & rör",
    description: "Installation, service och ombyggnation av VVS- och rörsystem.",
    bullets: [
      "Rörinstallationer",
      "VVS-installationer",
      "Service och reparation",
      "Ombyggnation vid renovering",
      "Installation vid nyproduktion",
      "Underhåll av befintliga installationer",
    ],
  },
  {
    id: "svets",
    num: "03",
    tag: "Svetsning & rörsvetsning",
    title: "Rörsvetsning",
    description: "Svetsning av rörsystem och tekniska installationer.",
    bullets: [
      "Rörsvetsning",
      "Svetsning av VVS-system",
      "Anpassning av befintliga installationer",
      "Tillverkning och modifiering",
      "Reparation",
      "Svetsarbeten ute på arbetsplats",
    ],
  },
  {
    id: "service",
    num: "04",
    tag: "Service & entreprenad",
    title: "Service & entreprenad",
    description: "Hjälp vid både mindre servicearbeten och större projekt.",
    bullets: [
      "Företag",
      "Byggföretag",
      "Fastighetsägare",
      "Bostadsrättsföreningar",
      "Privatpersoner",
    ],
  },
];

export const PROJECTS = [
  {
    id: "proj-fjarrvarme-stockholm",
    title: "Byte av fjärrvärmecentral – Stockholm",
    location: "Stockholm",
    type: "Fjärrvärme",
    description:
      "Byte och montering av ny fjärrvärmecentral med anpassning av befintliga rörsystem i fastighet.",
    image: "/assets/fjarrvarme-1.webp",
    alt: "Nymonterad fjärrvärmecentral med rörinstallation i Stockholm – Uusimaa Svets & VVS AB",
  },
  {
    id: "proj-fjarrvarme-huddinge",
    title: "Fjärrvärmecentral – Huddinge",
    location: "Huddinge",
    type: "Fjärrvärme",
    description:
      "Montering av ny fjärrvärmecentral med anpassad rördragning och inkoppling mot befintlig anläggning.",
    image: "/assets/fjarrvarme-4.webp",
    alt: "Nymonterad fjärrvärmecentral med pumpar i Huddinge – Uusimaa Svets & VVS AB",
  },
  {
    id: "proj-fjarrvarme-haninge",
    title: "Fjärrvärmecentral – Haninge",
    location: "Haninge",
    type: "Fjärrvärme",
    description:
      "Installation av fjärrvärmecentral i tekniskt rum – rördragning, inkoppling och injustering av anläggningen.",
    image: "/assets/fjarrvarme-2.webp",
    alt: "Fjärrvärmecentral med rördragning och expansionskärl i Haninge – Uusimaa Svets & VVS AB",
  },
  {
    id: "proj-fjarrvarme-nacka",
    title: "Byte av fjärrvärmecentral – Nacka",
    location: "Nacka",
    type: "Fjärrvärme",
    description:
      "Byte och installation av fjärrvärmecentral med nya pumpar, värmeväxlare och uppgraderad rörinstallation.",
    image: "/assets/fjarrvarme-5.webp",
    alt: "Byte av fjärrvärmecentral med ny rörinstallation i Nacka – Uusimaa Svets & VVS AB",
  },
  {
    id: "proj-fjarrvarme-tungelsta",
    title: "Fjärrvärmecentral – Tungelsta",
    location: "Tungelsta",
    type: "Fjärrvärme",
    description:
      "Byte av äldre fjärrvärmecentral mot ny anläggning med uppgraderad rörinstallation och nya komponenter.",
    image: "/assets/fjarrvarme-3.webp",
    alt: "Byte av fjärrvärmecentral i Tungelsta – Uusimaa Svets & VVS AB",
  },
  {
    id: "proj-rorsvetsning-stockholm",
    title: "Rörsvetsning – Stockholm",
    location: "Stockholm",
    type: "Rörsvetsning & VVS-svets",
    description:
      "Svetsning och anpassning av rörsystem i en VVS-anläggning. Varje fog utförs med samma noggrannhet – även på de ställen som aldrig kommer att synas.",
    image: "/assets/welding-sparks.webp",
    alt: "Rörsvetsning med gnistor på arbetsplats i Stockholm – Uusimaa Svets & VVS AB",
  },
];

export const WHY_POINTS = [
  {
    num: "01",
    title: "Noggrant utfört",
    desc: "Arbetet ska vara ordentligt gjort – även på de delar som du aldrig kommer att se.",
  },
  {
    num: "02",
    title: "Personlig kontakt",
    desc: "Du har direkt kontakt med hantverkarna som utför arbetet. Inga mellanhänder.",
  },
  {
    num: "03",
    title: "Flexibilitet",
    desc: "Som mindre företag kan vi snabbt anpassa arbetet efter projektets behov.",
  },
  {
    num: "04",
    title: "Storstockholm",
    desc: "Vi utför arbeten i hela Stockholmsområdet, med bas i Tungelsta.",
  },
];
